import {IUser} from "../../../../../app/interfaces/user/IUser";
import {IChatSocketCommand} from "../../../../../app/types/ChatSocketCommand";

export const hideChatCommand = (user: IUser, chatWithId: string): IChatSocketCommand => ({
    cmd: 'hide',
    userId: user.uniqueUserValue ?? user.idStr ?? '',
    toUserId: chatWithId
});